import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { createRepository } from '@/repositories/GenericRepository';
import type PaginatedResponse from '@/types/paginatedResponse';
import { UserChallenge } from '@/types/user_challenge';
import ajax from '@/utils/ajax';

const basePath = '/api/dugout/user_challenges';

export const userChallengeRepository = {
  ...createRepository<UserChallenge, UserChallenge>(basePath),

  async getMostRecentForPerson({
    host,
    personId
  }: {
    host: string;
    personId: string;
  }): Promise<UserChallenge | null> {
    const response = await ajax.get({
      params: { completed: true, member: personId, ordering: '-finished_at', size: 1 },
      url: `${host}${basePath}/`
    });

    const { results }: PaginatedResponse<UserChallenge[]> = response.data;

    return results[0] ?? null;
  },

  async getUserChallengeImageLink({
    id,
    host
  }: {
    id: number;
    host: string;
  }): Promise<{ url: string }> {
    const response = await ajax.get({
      url: `${host}${basePath}/user_challenge_images/${id}/link/`
    });

    return response.data;
  }
};

const UserChallengeRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async get({ id }: { id: string }) {
      return userChallengeRepository.get({ host, id });
    },

    async getMostRecentForPerson({ personId }: { personId: string }) {
      return userChallengeRepository.getMostRecentForPerson({ host, personId });
    },

    async getUserChallengeImageLink({ id }: { id: number }) {
      return userChallengeRepository.getUserChallengeImageLink({ id, host });
    }
  };
};

export default UserChallengeRepository;
